import React from "react";
import { Grid, TextField, Paper, Typography } from "@material-ui/core";
import StorefrontIcon from "@material-ui/icons/Storefront";
import { COLORS } from "../styles";

interface SourcePharmacyFormProps {
  ncpdp: string;
  npi: string;
  businessName: string;
  addressLine1: string;
  city: string;
  state: string;
  zipCode: string;
  onNCPDPChange: (value: string) => void;
  onNPIChange: (value: string) => void;
  onBusinessNameChange: (value: string) => void;
  onAddressLine1Change: (value: string) => void;
  onCityChange: (value: string) => void;
  onStateChange: (value: string) => void;
  onZipCodeChange: (value: string) => void;
  fieldErrors?: { [key: string]: string };
  disabled?: boolean;
}

const SourcePharmacyForm: React.FC<SourcePharmacyFormProps> = ({
  ncpdp,
  npi,
  businessName,
  addressLine1,
  city,
  state,
  zipCode,
  onNCPDPChange,
  onNPIChange,
  onBusinessNameChange,
  onAddressLine1Change,
  onCityChange,
  onStateChange,
  onZipCodeChange,
  fieldErrors = {},
  disabled = false,
}) => {
  return (
    <Grid item xs={12} style={{ marginTop: 24 }}>
      <Paper
        elevation={2}
        style={{
          padding: 24,
          borderRadius: 8,
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography
          variant="h6"
          style={{
            fontWeight: 600,
            marginBottom: 16,
            color: COLORS.textPrimary,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <StorefrontIcon style={{ color: "#546e7a" }} />
          Source Pharmacy (Transferring From)
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="sourcePharmacyNCPDP"
              label="NCPDP ID"
              variant="outlined"
              value={ncpdp}
              onChange={(e) => onNCPDPChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.sourcePharmacyNCPDP}
              helperText={fieldErrors.sourcePharmacyNCPDP || "7 digits"}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="sourcePharmacyNPI"
              label="NPI"
              variant="outlined"
              value={npi}
              onChange={(e) => onNPIChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.sourcePharmacyNPI}
              helperText={fieldErrors.sourcePharmacyNPI || "10 digits"}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="sourcePharmacyBusinessName"
              label="Business Name"
              variant="outlined"
              value={businessName}
              onChange={(e) => onBusinessNameChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.sourcePharmacyBusinessName}
              helperText={fieldErrors.sourcePharmacyBusinessName}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="sourcePharmacyAddressLine1"
              label="Address Line 1"
              variant="outlined"
              value={addressLine1}
              onChange={(e) => onAddressLine1Change(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.sourcePharmacyAddressLine1}
              helperText={fieldErrors.sourcePharmacyAddressLine1}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              name="sourcePharmacyCity"
              label="City"
              variant="outlined"
              value={city}
              onChange={(e) => onCityChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.sourcePharmacyCity}
              helperText={fieldErrors.sourcePharmacyCity}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              name="sourcePharmacyState"
              label="State"
              variant="outlined"
              value={state}
              onChange={(e) => onStateChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.sourcePharmacyState}
              helperText={fieldErrors.sourcePharmacyState}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              name="sourcePharmacyZipCode"
              label="Zip Code"
              variant="outlined"
              value={zipCode}
              onChange={(e) => onZipCodeChange(e.target.value)}
              fullWidth
              required
              disabled={disabled}
              error={!!fieldErrors.sourcePharmacyZipCode}
              helperText={fieldErrors.sourcePharmacyZipCode || "5 digits"}
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default SourcePharmacyForm;
